/**
 * @generated SignedSource<<11d58d61328a57354f03227472c48a7c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topicHeaderTopic$data = {
  readonly chineseName: string | null | undefined;
  readonly mobileImage: {
    readonly style: {
      readonly url: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly name: string;
  readonly sponsor: {
    readonly " $fragmentSpreads": FragmentRefs<"sponsorTagSponsor">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"entityFollowButtonBase" | "entityLink" | "hooksTopic" | "topicHeaderRelatedLinksTopic">;
  readonly " $fragmentType": "topicHeaderTopic";
};
export type topicHeaderTopic$key = {
  readonly " $data"?: topicHeaderTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"topicHeaderTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topicHeaderTopic",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "topicHeaderRelatedLinksTopic"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityFollowButtonBase"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "hooksTopic",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "types",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Sponsor",
          "kind": "LinkedField",
          "name": "sponsor",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__typename",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    },
    {
      "alias": "mobileImage",
      "args": [
        {
          "kind": "Literal",
          "name": "type",
          "value": "MOBILE_APP_IMAGE"
        }
      ],
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "image",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "filter",
              "value": {
                "style": "300x300"
              }
            }
          ],
          "concreteType": "ImageStyle",
          "kind": "LinkedField",
          "name": "style",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": "style(filter:{\"style\":\"300x300\"})"
        }
      ],
      "storageKey": "image(type:\"MOBILE_APP_IMAGE\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "chineseName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Sponsor",
      "kind": "LinkedField",
      "name": "sponsor",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "sponsorTagSponsor"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "03ed406e4d05d549cd1823a3d97f1713";

export default node;
